import React, { useCallback, useMemo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Accordion from '@groovehq/internal-design-system/lib/components/Accordion/Accordion'
import Skeleton from '@groovehq/internal-design-system/lib/components/Skeleton/Skeleton'
import Table from '@groovehq/internal-design-system/lib/components/Table/Table'
import { selectIsGroupsBootstrapped } from 'selectors/groups/selectIsGroupsBootstrapped'
import { DRAWER_TYPE_TEAM_UPDATE } from 'ducks/drawers/types'
import { useDrawer } from 'ducks/drawers/hooks'
import doFetchAllAgents from 'actions/agents/doFetchAllAgents'
import { selectAllAgentsFetched } from 'selectors/agents/base'

import { selectCurrentTeamsSortedByName } from 'ducks/teams/selectors'
import { styles } from './styles'

import AgentTable from './AgentTable'
import Title from './Title'

const { Empty } = Table

const TeamsAccordion = () => {
  const dispatch = useDispatch()

  const teams = useSelector(selectCurrentTeamsSortedByName)
  const isLoaded = useSelector(selectAllAgentsFetched)
  const isEmpty = teams.length === 0
  const isTeamsBootstrapped = useSelector(selectIsGroupsBootstrapped)
  const loading = !(isLoaded && isTeamsBootstrapped)

  useEffect(
    () => {
      if (loading) {
        dispatch(doFetchAllAgents())
      }
    },
    [dispatch, loading]
  )

  const {
    drawerId: editTeamDrawerId,
    openDrawer: openEditTeamDrawer,
  } = useDrawer(DRAWER_TYPE_TEAM_UPDATE)

  const handleOnEditTeam = useCallback(
    (teamId, options) => {
      openEditTeamDrawer(teamId, options)
    },
    [openEditTeamDrawer]
  )

  const teamAccordionItems = useMemo(
    () => {
      return teams.map(({ id, name }) => ({
        key: id,
        title: <Title teamId={id} name={name} />,
        content: (
          <AgentTable
            teamId={id}
            onEditTeam={handleOnEditTeam}
            editTeamDrawerId={editTeamDrawerId}
          />
        ),
      }))
    },
    [teams, handleOnEditTeam, editTeamDrawerId]
  )

  return (
    <>
      <div className="grui px-1">
        {loading && <Skeleton className="grui mb-5" count={4} height={51} />}
        {!loading &&
          isEmpty && (
            <Empty
              img={false}
              title={`There are no ${app.t('teams')}`}
              subtitle={`You haven’t created any ${app.t(
                'teams'
              )} on your account yet.`}
            />
          )}
        {!loading &&
          !isEmpty && (
            <Accordion list={teamAccordionItems} css={styles.accordionPanel} />
          )}
      </div>
    </>
  )
}

TeamsAccordion.displayName = 'TeamsAccordion'

export default TeamsAccordion
